import { environment } from "./environment";

export class APIPortResolver {
  static resolve(): string {
    var proto = window.location.protocol;
    var host = window.location.hostname;

    console.log(proto);
    console.log(host);
    if (environment.apiPort == 443 || environment.apiPort == 80) {
      //console.log('443xx');
      //return 'https://localhost:7500/api/';
      return proto + '//' + host + '/api/';
    } else {
      return proto + '//' + host + ':' + environment.apiPort + '/api/';
    }
  }
}
